declare namespace $ {

	export class $mol_icon_tune extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=tune.view.tree.d.ts.map